<template>
  <div>
    <a-card style="margin-bottom: 10px">
      <div class="filter-section">
      <a-form layout="inline" ref="form" :model="form">
        <a-form-item label="团队" name="teamId">
          <a-select
            v-if="isCManager"
            v-model:value="form.teamId"
            style="width: 140px">
            <a-select-option key="" value="">全部</a-select-option>
            <a-select-option v-for="t in teamList"
              :key="t.id"
              :value="t.id">
              {{ t.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item name="name">
          <a-input style="width: 200px"
            placeholder="请输入姓名"
            v-model:value="form.name"
            autocomplete="off">
            <template v-slot:suffix><search-outlined type="user"/></template>
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button @click="resetForm">重置</a-button>
          <a-button type="primary" @click="getData(1)">查询</a-button>
        </a-form-item>
      </a-form>
    </div>
    </a-card>
    <a-card>
      <div class="table-title">
        <p class="table-name">
          账号管理
        </p>
        <a-button
          type="primary"
          @click="toEditPage('add')">
          创建账号
        </a-button>
        <a-button
          type="primary"
          style="margin-left:10px;"
          @click="openRelevancy">
          关联账号
        </a-button>
      </div>
      <br>
      <a-table
        :columns="columns"
        :data-source="tableData"
        rowKey="userId"
        :pagination="false">
        <template v-slot:company="{ text }">
          {{ getCompanyAndRole(text) }}
        </template>
        <template v-slot:team="{ text }">
          {{ getTeamAndRole(text) }}
        </template>
        <template v-slot:time="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:status="{ text }">
          {{ getStatus(text) }}
        </template>
        <template v-slot:action="{ record }">
          <span class="gap-btn">
            <a @click="toEditPage('edit', record)">编辑</a>
          </span>
          <span class="gap-btn">
            <a @click="handleDelete(record)">删除</a>
          </span>
          <!-- <span class="gap-btn">
            <a @click="handleStatus(record)">{{ record.status === '1' ? '停用' : '启用'}}</a>
          </span> -->
        </template>
      </a-table>
      <br>
      <a-pagination
        :current="page.pageNum"
        show-quick-jumper
        :pageSize="showPageSize"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        @change="getData"
      ></a-pagination>
    </a-card>
    <UserEdit ref="userEdit" :dialogType="dialogType" :currentItem="currentItem"
      @update="getData()"></UserEdit>
    <Relevancy ref="relevancy" :currentItem="currentItem" @update="getData()"></Relevancy>
  </div>
</template>
<script>
import { SearchOutlined } from '@ant-design/icons-vue'
import { getUserByPage, getUserByPage2, deleteUser, handleUserStatus } from '@/api/user'
import { getTeamMember, removeUser } from '@/api/team'
import { getCompanyMember } from '@/api/company'
import { getDateTime, getCompanyName, getTeamName, getRoleName } from '@/filters'
import { mapState } from 'vuex'
import UserEdit from './EditDialog'
import Relevancy from './RelevancyDialog.vue'
const columns = [
  {
    title: '姓名',
    width: '160px',
    dataIndex: 'name'
  },
  {
    title: '账号',
    width: '160px',
    dataIndex: 'username'
  },
  // {
  //   title: '公司',
  //   dataIndex: 'companies',
  //   slots: { customRender: 'company' }
  // },
  {
    title: '团队',
    dataIndex: 'teams',
    slots: { customRender: 'team' }
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: '180px',
    slots: { customRender: 'time' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: '100px',
    slots: { customRender: 'status' }
  },
  {
    title: '操作',
    width: '160px',
    slots: { customRender: 'action' }
  }
]

export default {
  components: {
    SearchOutlined,
    UserEdit,
    Relevancy
  },
  data () {
    return {
      form: {
        teamId: '',
        name: ''
      },
      tableData: [],
      columns,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      showPageSize: 10,
      total: 0,
      dialogType: 'add',
      currentItem: {}
    }
  },
  computed: {
    ...mapState(['currentRole', 'teamList']),
    isCManager () {
      return this.currentRole.roleId === '7' || this.currentRole.roleId === '13'
    }
  },
  async mounted () {
    this.getData()
  },
  methods: {
    getDateTime,
    getCompanyName,
    getTeamName,
    getRoleName,
    getStatus (input) {
      return input === '1' ? '已启用' : '已停用'
    },
    getTeamAndRole (tms) {
      if (tms && tms.length && Array.isArray(tms)) {
        return tms.map(tm => `${getTeamName(tm.teamId)}(${getRoleName(tm.roleId)})`).join(',')
      } else {
        return ''
      }
    },
    getCompanyAndRole (cps) {
      if (cps && cps.length && Array.isArray(cps)) {
        return cps.map(cp => {
          const cName = getCompanyName(cp.companyId)
          const rName = cp.roleId === '7' ? '(数据公司管理员)'
            : cp.roleId === '13' ? '(标注公司管理员)' : ''
          return cName + rName
        }).join(',')
      } else {
        return ''
      }
    },
    resetForm () {
      this.$refs.form.resetFields()
    },
    async getData (pageNum) {
      this.showPageSize = 10
      if (pageNum) this.page.pageNum = pageNum
      if (this.form.name) { // 有姓名，先查user/selectList
        const resOfUser = await getUserByPage2({ ...this.page, pageSize: 10000, name: this.form.name })
        const userList = resOfUser.data.data.rows
        const pList = userList.map(async user => {
          await getCompanyMember({ userId: user.userId }).then(res => {
            user.companies = res.data.map.data.rows
          })
          return getTeamMember({ userId: user.userId }).then(res => {
            user.teams = res.data.map.data.rows
          })
        })
        Promise.all(pList).then(() => {
          this.tableData = userList.filter(u => u.companies.some(cm => cm.companyId === this.currentRole.companyId) &&
          (!this.form.teamId || u.teams.some(tm => tm.teamId === this.form.teamId)))
          this.showPageSize = this.tableData.length
          this.total = this.tableData.length
        })
      } else if (this.isCManager && !this.form.teamId) { // 公司管理员，并且不筛选团队，则查companyMember
        const companyId = this.currentRole.companyId
        getCompanyMember({ ...this.page, companyId }).then(async res => {
          const data = res.data.map.data.rows
          this.tableData = await this.getUserListInfo(data)
          this.total = res.data.map.data.total
        })
      } else { // 团队管理员或者公司管理员筛选团队，查teamMember
        const teamId = this.isCManager && this.form.teamId ? this.form.teamId : this.currentRole.teamId
        getTeamMember({ ...this.page, pageSize: 10000, teamId }).then(async res => {
          const data = res.data.map.data.rows
          this.tableData = await this.getUserListInfo(data, teamId)
          this.showPageSize = this.tableData.length
          this.total = this.tableData.length
        })
      }
    },
    async getUserListInfo (list, teamId) {
      const result = []
      for (const info of list) {
        const res = await getUserByPage({ userId: info.userId })
        const user = res.data.data.rows[0]
        if (user && !result.some(u => u.userId === user.userId)) {
          await getCompanyMember({ userId: user.userId }).then(res => {
            user.companies = res.data.map.data.rows
          })
          await getTeamMember({ userId: user.userId }).then(res => {
            user.teams = res.data.map.data.rows.filter(t => !teamId || t.teamId === teamId)
          })
          result.push(user)
        } else {
          if (!user) {
            console.error('用户不存在', info.userId)
          } else {
            console.error('公司/团队重复', user)
          }
        }
      }
      return result
    },
    getData1 (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      let action = getUserByPage2
      let params = this.page
      if (Object.values(this.form).some(value => value)) {
        action = getUserByPage2
        params = { ...this.page, ...this.form }
      }
      action(params).then(async res => {
        const resData = res.data.data
        this.total = resData.total
        this.tableData = resData.rows
        for (let i = 0; i < this.tableData.length; i++) {
          const user = this.tableData[i]
          await getCompanyMember({
            userId: user.userId
          }).then(res => {
            user.companies = res.data.map.data.rows
          })
          await getTeamMember({
            userId: user.userId
          }).then(res => {
            user.teams = res.data.map.data.rows
          })
        }
      })
    },
    toEditPage (type, item) {
      this.dialogType = type
      if (type === 'edit') {
        this.currentItem = item
      } else {
        this.currentItem = {}
      }
      this.$refs.userEdit.open()
    },
    openRelevancy(item){
      this.$refs.relevancy.open()
      this.currentItem = {}
    },
    openOrganDialog (item) {
      this.currentItem = item
      this.$refs.organDialog.open()
    },
    handleDelete (record) {
      console.log(JSON.parse(JSON.stringify(record)))
      this.$confirm({
        title: '删除账号',
        content: '确认删除账号？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          removeUser({
            teamId:record.teams[0].teamId,
            userId:record.userId
          }).then(res => {
            this.$message.success('已删除')
            this.getData()
          })
        },
        onCancel () {
          console.log('cancel')
        }
      })
    },
    handleStatus (record) {
      const status = record.status === '1' ? '0' : '1'
      this.$confirm({
        title: record.status === '1' ? '停用账号' : '启用账号',
        content: record.status === '1' ? '确认停用账号？' : '确认启用账号',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          handleUserStatus(record).then(res => {
            record.status = status
            this.$message.success('操作成功')
          })
        },
        onCancel () {
          console.log('cancel')
        }
      })
    }
  }
}
</script>
<style>

</style>
